module.exports = __webpack_public_path__ + "fonts/iconfont.0bf262e8.ttf";